var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleClientRendering',[_c('CycleIframe',{attrs:{"href":_vm.href}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }